import React from 'react'
import { Modal, Input, Icon, message } from 'antd'

import FileResults from './file-results'
import FileInfo from './file-info'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'
import MediaInfo from '../MediaInfo'
import Share from '../FilesShare/share'

import './styles.scss'

export default class Omnibox extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            selected_file_index: 0,
            keyword: this.props.keyword,
            loading: false,
            files: [],

            share_loading: false,
            slack_channels: [],
            slack_channel: '',
            share_on_slack: '',
            share_recipients: [],
            share_select_all: true,
            share_files: [],

            share_expiration: 604800,
        }
    }

    componentDidMount() {
        const { keyword } = this.props
        if (keyword !== '') {
            this.on_search(keyword)
        }
    }

    timeOutSearch = keyword => {
        clearTimeout(this.tm)
        this.tm = setTimeout(() => this.on_search(keyword), 500)
    }

    on_search = keyword => {
        let $this = this
        $this.setState({ keyword, loading: true })
        CloudFlyerAPI.storages
            .search({ keyword, config: { limit: 10 } })
            .then(({ data: { count = 0, results = [] } = {} }) =>
                $this.setState({
                    files: results.filter(
                        _ => _.type === 'FS_FILE_TYPE_FILE' && _.key.length < 50
                    ),
                    loading: false,
                })
            )
            .catch(err => {
                console.error(err)
                $this.setState({ loading: false })
                message.error(err.message)
            })
    }

    on_file_select = index => {
        this.setState({ selected_file_index: index })
    }

    on_arrow_navigation = ({ keyCode }) => {
        if (keyCode !== 38 && keyCode !== 40) return
        const { selected_file_index } = this.state
        if (keyCode === 38 && selected_file_index > 0) {
            this.setState({
                selected_file_index: selected_file_index - 1,
            })
        }
        if (
            keyCode === 40 &&
            selected_file_index < this.state.files.length - 1
        ) {
            this.setState({
                selected_file_index: selected_file_index + 1,
            })
        }
    }

    on_delete = file => {
        let $this = this
        this.setState({ delete_loading: true })
        CloudFlyerAPI.transfer
            .delete_object(file.cloud_account_id, file.bucket.bucket_name, [
                file.path,
            ])
            .then(res => {
                $this.setState({ delete_loading: false })
                if (!((res || {}).data || {})) {
                    return message.error(
                        'failed to delete files, please retry again'
                    )
                }
                message.success(((res || {}).data || {}).message || '')
            })
            .catch(err => {
                $this.setState({ delete_loading: false })
                message.error(err)
            })
    }

    on_download = file => {
        let $this = this
        $this.setState({ dl_loading: true })

        CloudFlyerAPI.transfer
            .download_url(file.cloud_account_id, file.bucket_name, [file.key])
            .then(res => {
                $this.setState({ dl_loading: false })
                if (!((res || {}).data || {})) {
                    return message.error(
                        'failed to generate download link, please retry again'
                    )
                }
                $this.setState({ download_files: [] }, () =>
                    $this.setState({ download_files: (res || {}).data || {} })
                )
            })
            .catch(err => {
                $this.setState({ dl_loading: false })
                message.error(err)
            })
    }

    on_show_media_info = file => {
        file.basename = file.path = file.key
        this.media_info.open({
            ...file,
            ...{
                bucket_name: file.bucket_name,
                cloud_account_id: file.cloud_account_id,
            },
        })
    }

    on_share = file => {
        let $this = this
        file.share = true
        file.basename = file.key

        $this.setState(
            {
                share_visible: true,
                share_select_all: true,
                share_files: [file],
            },
            () => {
                CloudFlyerAPI.slack
                    .channels()
                    .then(({ data: slack_channels }) =>
                        $this.setState({ slack_channels }, () =>
                            $this.props.refresh_profile(true)
                        )
                    )
                    .catch(console.warn)
            }
        )
    }

    on_share_cancel = () => {
        this.setState({ share_visible: false })
    }

    on_share_select = (file, share) => {
        for (let key in this.state.share_files) {
            let item = this.state.share_files[key]
            if (item.basename === file.basename) {
                item.share = share
                this.setState({
                    share_files: this.state.share_files,
                    share_select_all: false,
                })
                return
            }
        }
    }

    on_copy_link = file => {
        if (!file) {
            return
        }

        try {
            let textArea = document.createElement('textarea')
            textArea.style.position = 'fixed'
            textArea.style.top = 0
            textArea.style.left = 0
            textArea.style.width = '2em'
            textArea.style.height = '2em'
            textArea.style.padding = 0
            textArea.style.border = 'none'
            textArea.style.outline = 'none'
            textArea.style.boxShadow = 'none'
            textArea.style.background = 'transparent'
            textArea.value = file.download_url
            document.body.appendChild(textArea)
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
        } catch (e) {}

        message.success('Link copied!')
    }

    on_generate_link = (file, hide_message) => {
        let $this = this
        file.generating_link = true

        CloudFlyerAPI.transfer
            .download_url(file.cloud_account_id, file.bucket_name, [file.key])
            .then(response => {
                file.generating_link = false

                if (!(response || {}).data) {
                    return message.error(
                        'failed to generate download link, please retry again'
                    )
                }

                file.download_url = (response || {}).data[0].url
                $this.setState({ files: this.state.files })

                if (!hide_message) message.success('Link generated !')
            })
            .catch(err => {
                file.generating_link = false
                file.download_url = null
                $this.setState({ files: this.state.files })
                message.error(err)
            })
    }

    on_copy_dll = async file => {
        if (!file) {
            return
        }

        if (!file.download_url)
            return (file.download_url = (await CloudFlyerAPI.transfer.download_url(
                file.cloud_account_id,
                file.bucket_name,
                [file.key]
            )).data[0].url)
        this.on_copy_link(file)
    }

    on_share_files = files => {
        let $this = this
        $this.setState({ share_loading: true })

        let share_files = []

        for (let key in files) {
            share_files.push({
                name: files[key].key,
                size: files[key].size,
                acl: 'private',
                bucket_name: files[key].bucket_name,
                cloud_account_id: files[key].cloud_account_id,
            })
        }

        if (share_files.length <= 0 || $this.state.share_recipients.length <= 0)
            return

        CloudFlyerAPI.transfer
            .share_by_email_files({
                files: share_files,
                recipients: $this.state.share_recipients,
                password: $this.state.share_password,
                expiration: $this.state.share_expiration,
            })
            .then(() => {
                $this.setState({
                    share_visible: false,
                    share_loading: false,
                })
                message.success('files shared successfully')
            })
            .catch(err => {
                $this.setState({ share_loading: false })
                message.error(err.message)
            })
    }

    on_recipient_change = recipients => {
        this.setState({ share_recipients: recipients })
    }

    on_share_password_change = ({ target }) =>
        this.setState({ share_password: target.value })

    on_share_expiration_change = value =>
        this.setState({ share_expiration: value })

    on_share_select_all = check_all => {
        for (let key in this.state.files) {
            this.state.files[key].share = check_all
        }

        this.setState({
            files: this.state.files,
            share_select_all: check_all,
        })
    }

    on_play = file => {
        file.play = !file.play
        this.on_generate_link(file, true)
        this.setState({})
    }

    render() {
        const { files, keyword, selected_file_index } = this.state
        return (
            <Modal
                visible={this.props.visible}
                className="modal-search"
                closable={false}
                footer={null}
                width={700}
                onCancel={this.props.onCancel}>
                <div
                    tabIndex="0"
                    style={{ outline: 'none' }}
                    onKeyDown={this.on_arrow_navigation}>
                    <Input
                        placeholder="Search across all accounts"
                        size="large"
                        value={keyword}
                        prefix={
                            this.state.loading ? (
                                <Icon type="loading" />
                            ) : (
                                <Icon type="search" />
                            )
                        }
                        onKeyDown={e =>
                            e.keyCode === 13
                                ? this.timeOutSearch(e.currentTarget.value)
                                : null
                        }
                        onChange={e => {
                            this.timeOutSearch(e.target.value)
                            this.setState({ keyword: e.target.value })
                        }}
                        autoFocus
                    />
                    {keyword && files && files.length > 0 && (
                        <div className="result-container">
                            <FileResults
                                files={files}
                                selected_file_index={selected_file_index}
                                on_file_select={this.on_file_select}
                            />
                            <FileInfo
                                file={files[selected_file_index]}
                                on_download={this.on_download}
                                on_copy_dll={this.on_copy_dll}
                                on_delete={this.on_delete}
                                on_share={this.on_share}
                                on_play={this.on_play}
                                on_show_media_info={this.on_show_media_info}
                            />
                        </div>
                    )}

                    {this.state.share_visible && (
                        <Share
                            files={this.state.share_files}
                            recipients={this.state.share_recipients}
                            visible={this.state.share_visible}
                            select_all={this.state.share_select_all}
                            loading={this.state.share_loading}
                            password={this.state.share_password}
                            expiration={this.state.share_expiration}
                            channels={[]}
                            channel={''}
                            share_on_slack={''}
                            use_weblink={false}
                            on_channel_change={''}
                            on_cancel={this.on_share_cancel}
                            on_select={this.on_share_select}
                            on_copy_link={this.on_copy_link}
                            on_generate_link={this.on_generate_link}
                            on_share_files={this.on_share_files}
                            on_recipient_change={this.on_recipient_change}
                            on_password_change={this.on_share_password_change}
                            on_expiration_change={
                                this.on_share_expiration_change
                            }
                            on_select_all={this.on_share_select_all}
                        />
                    )}

                    <MediaInfo ref={n => (this.media_info = n)} />

                    <div className={'hidden'}>
                        {(this.state.download_files || []).map((file, i) => (
                            <iframe
                                key={i}
                                download={file.url}
                                src={file.url}
                            />
                        ))}
                    </div>
                </div>
            </Modal>
        )
    }
}
